import styled from 'styled-components';
import { Layout } from 'antd';

import { FeaturedSection, Hero, LatestSection, StatsSection, ServiceIntroSection, PartnerCarousel, LandingDraftButton } from '../component/landing';
import { NoticePopup } from '../component/common';

const { Content } = Layout;

const Landing = () => {
  return (
    <StyledLayout>
      <NoticePopup>
        현재 사이트 구축 중으로 완성된 사이트가 아닙니다.
        <br />
        현재 manuscript 작성 및 검증, slide annotation 진행중입니다.
      </NoticePopup>

      <Content>
        <Hero />
        <StatsSection />
        <ServiceIntroSection
          label="DIGITAL SLIDE VIEWER"
          title={`High-Resolution Whole Slide Image Viewing`}
          subtitle="Provides a web-based viewing environment for digital pathology slides."
          description=""
          image="/img/main/main_viewer.PNG"
          imagePosition="left"
        />
        <ServiceIntroSection
          label="ATLAS GALLERY"
          title={`Organ-Specific Disease Gallery`}
          subtitle="Provides a structured grid view of pathology cases categorized by organ systems."
          description=""
          image="/img/main/main_gallery.PNG"
          imagePosition="left"
        />
        <ServiceIntroSection
          label="SLIDE ANNOTATION"
          title={`Interactive Annotation and Labeling Tools`}
          subtitle="You can draw arrows, shapes, and add text labels to highlight morphological features for detailed analysis."
          description=""
          image="/img/main/main_annotation.PNG"
          imagePosition="left"
        />
        <Section>
          <div className="container">
            <FeaturedSection />
            <LatestSection />
          </div>
        </Section>

        <PartnerCarousel />
      </Content>

      <LandingDraftButton />
    </StyledLayout>
  );
};

const StyledLayout = styled(Layout)`
  background: #f1f1f1;
`;

const Section = styled.section`
  padding: 60px 0;
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
`;

export default Landing;